import { Component, EventEmitter, Output } from "@angular/core";
import { AppService } from "@app/app.service";
import { ReportsService } from "../reports.service";

@Component({
	selector: "tg-reports-filter-bar",
	templateUrl: "./reports-filter-bar.component.html",
	styleUrls: ["./reports-filter-bar.component.scss"],
})
export class ReportsFilterBarComponent {
	constructor(
		public reports: ReportsService,
		private appService: AppService
	) {}

	@Output() resetFilters = new EventEmitter<void>();
	@Output() manageDashboards = new EventEmitter<void>();
	@Output() showCompletedChange = new EventEmitter<boolean>();

	readonly isDefaultFilter$ = this.reports.isDefaultFilter$;
	readonly showManageDashboards$ = this.reports.showManageDashboards$;
	readonly showFilters$ = this.reports.showFilters$;
	readonly currentPage = this.reports.currentPage;
	readonly teamFilter = this.reports.teamFilter;
	readonly groupFilter = this.reports.groupFilter;
	readonly comegoTypeFilter = this.reports.comegoTypeFilter;
	readonly projectFilter = this.reports.projectFilter;
	readonly clientFilter = this.reports.clientFilter;
	readonly taskFilter = this.reports.taskFilter;
	readonly tagFilter = this.reports.tagFilter;
	readonly billableFilter = this.reports.billableFilter;
	readonly billableFilter$active = this.reports.billableFilter$active;
	readonly auditFilter = this.reports.auditFilter;
	readonly auditFilter$active = this.reports.auditFilter$active;
	readonly amountToggle = this.reports.amountToggle;
	readonly noStartDateToggle = this.reports.noStartDateToggle;
	readonly canViewAmount = this.reports.canViewAmount;
	readonly showCompletedProjects$ = this.reports.showCompletedProjects$;
	readonly userIsAdmin = this.reports.userIsAdmin;
	readonly userIsWorkspaceManager = this.reports.userIsWorkspaceManager;
	readonly comegoEnabled$ = this.appService.comegoEnabled$;
	readonly viewOnlyOwnContingent = this.reports.viewOnlyOwnContingent;
	readonly employeeFilterIncludesRemoved = this.reports.employeeFilterIncludesRemoved$;
}
